import type {Metric} from 'web-vitals'

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (typeof onPerfEntry === 'function') {
    import('web-vitals').then(({onCLS, onFCP, onLCP, onTTFB, onINP}) => {
      onCLS(onPerfEntry)
      onFCP(onPerfEntry)
      onLCP(onPerfEntry)
      onTTFB(onPerfEntry)
      onINP(onPerfEntry) // replaces FID in v5
    })
  }
}

export default reportWebVitals
